const accordionIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2073 7.58824H1.79268C1.65124 7.58824 1.53659 7.70675 1.53659 7.85294V13.1471C1.53659 13.2933 1.65124 13.4118 1.79268 13.4118H19.2073C19.3488 13.4118 19.4634 13.2933 19.4634 13.1471V7.85294C19.4634 7.70675 19.3488 7.58824 19.2073 7.58824ZM1.79268 6C0.802612 6 0 6.82959 0 7.85294V13.1471C0 14.1704 0.802611 15 1.79268 15H19.2073C20.1974 15 21 14.1704 21 13.1471V7.85294C21 6.82959 20.1974 6 19.2073 6H1.79268Z"
      fill="#6B00DF"
    />
    <path
      d="M2.56098 10.5C2.56098 10.0614 2.90495 9.70588 3.32927 9.70588H14.5976C15.0219 9.70588 15.3659 10.0614 15.3659 10.5C15.3659 10.9386 15.0219 11.2941 14.5976 11.2941H3.32927C2.90495 11.2941 2.56098 10.9386 2.56098 10.5Z"
      fill="#6B00DF"
    />
    <path
      d="M18.439 10.5C18.439 10.0614 18.095 9.70588 17.6707 9.70588H17.1585C16.7342 9.70588 16.3902 10.0614 16.3902 10.5C16.3902 10.9386 16.7342 11.2941 17.1585 11.2941H17.6707C18.095 11.2941 18.439 10.9386 18.439 10.5Z"
      fill="#6B00DF"
    />
  </svg>
);

export { accordionIcon };
